import { render } from "./SkeletonSet.vue?vue&type=template&id=1b22f0cc"
import script from "./SkeletonSet.vue?vue&type=script&lang=js"
export * from "./SkeletonSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__